import { HTMLAttributes } from 'react'

import LoadMoreButton, {
  LoadMoreProps as LoadMoreButtonProps
} from '@/components/base/load-more-button'

type LoadMoreProps = HTMLAttributes<HTMLElement> &
  Pick<LoadMoreButtonProps, 'fetching'>

const LoadMore = ({ fetching, ...props }: LoadMoreProps) => {
  return (
    <section {...props}>
      <div className="text-center">
        <LoadMoreButton fetching={fetching} />
      </div>
    </section>
  )
}

export default LoadMore
